import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const Keyword = ({ editor ,setIsOpen,setShowFMatter}) => {
  const [keywords, setKeywords] = useState([]);
  useEffect(() => {
    if (!editor) return;

    const keywords = editor?.dom.select("kwd");

    const parsed = keywords.map((affElement, index) => {
      return {
        index,
        tag: affElement.tagName.toLowerCase(),
        value: affElement.innerHTML,
      };
    });

    setKeywords(parsed);
  }, [editor]);

  const handleChange = (i, value) => {
    setKeywords((prev) =>
      prev.map((item, index) =>
        i === index ? { ...item, value: value } : item
      )
    );
  };

  const handleAddRow = (i) => {
    const newItem = {
      index: keywords.length,
      tag: "kwd",
      value: "",
    };
    setKeywords((prev) => [
      ...prev.slice(0, i + 1),
      newItem,
      ...prev.slice(i + 1),
    ]);
  };

  const handleRemoveRow = (i) => {
    setKeywords((prev) => prev.filter((_, index) => index !== i));
  };
const handleCancel = () => {
   setIsOpen(null)
    setShowFMatter({
    authorgrouping: false,
    affiliation: false,
    keywords: false,
  })
  };
  const handleSubmit = () => {
     editor.undoManager.transact(() => {
    const parent = editor?.dom?.select("kwd-group")[0];

    if (!parent) {
      console.error("No kwd-group found in the editor");
      return;
    }

    // Clear existing <kwd> elements first
    editor.dom.select("kwd").forEach((el) => editor.dom.remove(el));

    // Append new/edited elements
    keywords.forEach((item) => {
      editor.dom.add(parent, item.tag, {}, item.value);
    });
    toast.success("Changes Updated")

    handleCancel();
  })
  };

  return (
    <div className="w-full h-fit">
      <div className="flex flex-col">
        <div className="flex flex-col overflow-auto [&::-webkit-scrollbar]:hidden rounded-lg py-1 bg-white border border-grey">
          {keywords?.map((data, i) => {
            return (
              <div key={i} className="flex flex-col gap-2 text-[13px] p-2  ">
                <div key={i} className="flex flex-col gap-2 ">
                  <div className="flex justify-between items-center">
                    <label className="text-[15px]">Keyword</label>

                    <div className="flex gap-2">
                      <button
                        title="Add"
                        className="text-nowrap text-refbtnhover hover:bg-refbtnhover hover:text-white p-[2px] rounded-[3px]"
                        onClick={() => handleAddRow(i)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-plus"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 5l0 14" />
                          <path d="M5 12l14 0" />
                        </svg>
                      </button>
                      <button
                        title="Remove"
                        className=" text-nowrap text-red hover:text-white hover:bg-red rounded-[3px] p-[2px]"
                        onClick={() => handleRemoveRow(i)}
                        disabled={keywords.length === 1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M4 7l16 0" />
                          <path d="M10 11l0 6" />
                          <path d="M14 11l0 6" />
                          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <input
                    title={data.value}
                    className="border-[1px] border-grey outline-none p-2"
                    type="text"
                    value={data.value}
                    onChange={(e) => handleChange(i, e.target.value)}
                  />
                </div>
              </div>
            );
          })}
        </div>

        <div className="ml-auto">
          <div className="flex pt-3 gap-4">
            <button
              className="px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border border-grey hover:border-[#20c77c]"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Keyword;
